import { Droppable as DndDroppable } from "@hello-pangea/dnd";

import { Segment } from "semantic-ui-react";

import React from "react";

export default function Droppable({ id, children, type, disabled, minHeight = 80, text }) {
	return (
		<DndDroppable droppableId={id} type={type} isDropDisabled={disabled}>
			{({ innerRef, placeholder, droppableProps }, { isDraggingOver }) => {
				return (
					<div
						ref={innerRef}
						style={{
							position: "relative",
							overflow: "hidden",
							minHeight: minHeight,
						}}
						{...droppableProps}
					>
						{text && (
							<Segment
								placeholder
								textAlign="center"
								style={{
									position: "absolute",
									padding: 0,
									top: "1em",
									width: "100%",
									minHeight: `calc(${minHeight}px - 1em)`,
									opacity: isDraggingOver ? 1 : 0.5,
								}}
							>
								{text}
							</Segment>
						)}

						{children}

						{placeholder}
					</div>
				);
			}}
		</DndDroppable>
	);
}
